export default class ProxyChecker {

    private static proxyMappings: { [key: string]: string } = {
        'sharemagazines.cloudwifi.de': 'https://app.sharemagazines.cloudwifi.de/',
        'sharemagazines.dev.frederix.cloud': 'https://app.sharemagazines.dev.frederix.cloud/',
        'sharemagazines.beta.frederix.cloud': 'https://app.sharemagazines.beta.frederix.cloud/'
    };

    /**
     * For a customer it's necessary to change the BASE URL to a proxy server hosted by the customer
     * because the clients used by the customer are only allowed to fetch data from proxy server
     */
    public static getBaseURL(): string {
        for (const key in ProxyChecker.proxyMappings) {
            if (window.location.hostname.includes(key)) {
                return ProxyChecker.proxyMappings[key];
            }
        }
        return process.env.VUE_APP_BASE_URL!;
    }
}
